/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
import Maps from "views/examples/Maps.js";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import Advertiser from "layouts/Advertiser/Advertiser";
import Dashboard from "layouts/Dashboard/Dashboard";
import AdvertiserReport from "layouts/Advertiser/AdvertiserReport";
import AddCampaign from "layouts/Campaign/AddCampaign";
import OfferType from "layouts/OfferType/OfferType";
import ViewCampaign from "layouts/Campaign/ViewCampaign";
import TrackingPanel from "layouts/TrackingPanel/TrackingPanel";
import LiveCampaign from "layouts/Campaign/LiveCampaign";
import OfferStatus from "layouts/OfferStatus/OfferStatus";
import PauseCampaign from "layouts/Campaign/PauseCampaign";
import ScheduleCampaign from "layouts/Campaign/ScheduleCampaign";
import OfferAnalyticsList from "layouts/Analytics/OfferAnalyticsList";
import Cronjobs from "layouts/Cronjobs/Cronjobs";


var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <Dashboard />,
    layout: "/admin",
    submenu: []
  },
  {
    path: "/admin",
    name: "Analytics",
    icon: "ni ni-planet text-blue",
    component: <OfferAnalyticsList />,
    layout: "/admin",
    submenu: [
      {
        name: "Offer",
        layout: "/admin",
        path: "/offeranalytics",
        component: <OfferAnalyticsList />,
      },
      
      
    ],
  },
  {
    name: "Campaigns",
    layout: "/admin",
    path: "/components",
    icon: "ni ni-single-02 text-yellow",
    component: <AddCampaign />,
    submenu: [
      {
        name: "Add Campaign",
        layout: "/admin",
        path: "/campaign/add",
        component: <AddCampaign />,
      },
      // {
      //   name: "All Offers",
      //   layout: "/admin",
      //   path: "/capaign/view",
      //   component: <ViewCampaign />,
      // },
      {
        name: "Live Offers",
        layout: "/admin",
        path: "/campaign/live",
        component: <LiveCampaign />,
      },
      {
        name: "Paused Offers",
        layout: "/admin",
        path: "/campaign/pause",
        component: <PauseCampaign />,
      },
      {
        name: "Scheduled Offers",
        layout: "/admin",
        path: "/campaign/schedule",
        component: <ScheduleCampaign />,
      },

    ],
  },
  {
    path: "/admin",
    name: "Schedule",
    icon: "ni ni-single-02 text-blue",
    component: <Cronjobs />,
    layout: "/admin",
    submenu: [
      {
        name: "Cronjob",
        layout: "/admin",
        path: "/cronjobs",
        component: <Cronjobs />,
      },
      
      
    ],
  },
 
  {
    path: "/offertype",
    name: "Utility",
    icon: "ni ni-planet text-blue",
    component: <OfferType />,
    layout: "/admin",
    submenu: [
      {
        name: "Offer Type",
        layout: "/admin",
        path: "/offertype",
        component: <OfferType />,
      },
      {
        name: "Offer Status",
        layout: "/admin",
        path: "/offer_status",
        component: <OfferStatus />,
      },
      {
        name: "Panel",
        layout: "/admin",
        path: "/panel",
        component: <TrackingPanel />,
      },

      
    ],
  },
  {
    path: "/icons",
    name: "Report",
    icon: "ni ni-planet text-blue",
    component: <Icons />,
    layout: "/admin",
    submenu: [
      {
        name: "Campaign Analytic",
        layout: "/admin",
        path: "/components/buttons",
      },
      
    ],
  },
  
  {
    path: "/advertiser",
    name: "Advertiser",
    icon: "ni ni-pin-3 text-orange",
    component: <Advertiser />,
    layout: "/admin",
    submenu: [
      {
        name: "Add",
        layout: "/admin",
        path: "/advertiser",
        component: <Advertiser />,
      },
      {
        name: "Report",
        layout: "/admin",
        path: "/advertiser-report",
         component: <AdvertiserReport />,
      },
      
    ],
  },
  {
    path: "/panels",
    name: "Rule/Condition",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
    submenu: [
      {
        name: "Add",
        layout: "/admin",
        path: "/components/buttons",
      },
      {
        name: "View",
        layout: "/admin",
        path: "/components/buttons",
      },
      {
        name: "Report",
        layout: "/admin",
        path: "/components/buttons",
      },
      
    ],
  },
  {
    path: "/tables",
    name: "Users",
    icon: "ni ni-bullet-list-67 text-red",
    component: <Tables />,
    layout: "/admin",
    submenu: [
      {
        name: "Add",
        layout: "/admin",
        path: "/components/buttons",
      },
      {
        name: "View",
        layout: "/admin",
        path: "/components/buttons",
      },
      {
        name: "Report",
        layout: "/admin",
        path: "/components/buttons",
      },
      
    ],
  },
 
];


export default routes;
